export default __webpack_public_path__ + "static/B0094-09f8c8edbb494949fd54be5108014f12.png";